import React from "react";
import PropTypes from "prop-types";
import "./MetricCard.css";

const MetricCard = ({
  icon,
  label,
  value,
  trend = null,
  trendValue = null,
  color = "blue",
}) => {
  const getTrendIcon = () => {
    if (!trend) return null;
    return trend === "up" ? "📈" : "📉";
  };

  const getTrendClass = () => {
    if (!trend) return "";
    return trend === "up" ? "metric-trend-up" : "metric-trend-down";
  };

  return (
    <div
      className={`metric-card metric-card-${color}`}
      role="article"
      aria-label={`${label} metric`}
    >
      <div className="metric-card-header">
        <div className="metric-card-icon" aria-hidden="true">
          {icon}
        </div>
        <div className="metric-card-label">{label}</div>
      </div>

      <div className="metric-card-value">{value}</div>

      {trend && trendValue && (
        <div className={`metric-card-trend ${getTrendClass()}`}>
          <span
            className="metric-trend-icon"
            role="img"
            aria-label={trend === "up" ? "Trending up" : "Trending down"}
          >
            {getTrendIcon()}
          </span>
          <span className="metric-trend-value">{trendValue}</span>
        </div>
      )}
    </div>
  );
};

MetricCard.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  trend: PropTypes.oneOf(["up", "down"]),
  trendValue: PropTypes.string,
  color: PropTypes.oneOf([
    "blue",
    "green",
    "red",
    "yellow",
    "purple",
    "orange",
  ]),
};

export default MetricCard;
